import { createSlice, createAction } from '@reduxjs/toolkit';
import { normalizeCapabilities, getDefaultCapabilities } from '../utils/capabilitiesNormalizer';

export const fetchCapabilitiesRequest = createAction('capabilities/fetchCapabilitiesRequest');

const initialState = {
    capabilities: getDefaultCapabilities(),
    loading: false,
    error: null,
};

const capabilitiesSlice = createSlice({
    name: 'capabilities',
    initialState,
    reducers: {
        fetchCapabilitiesStart: (state) => {
            state.loading = true;
            state.error = null;
        },
        fetchCapabilitiesSuccess: (state, action) => {
            state.loading = false;
            state.capabilities = normalizeCapabilities(action.payload);
            state.error = null;
        },
        fetchCapabilitiesFailure: (state, action) => {
            state.loading = false;
            state.error = action.payload;
        },
        clearCapabilities: (state) => {
            state.capabilities = getDefaultCapabilities();
            state.loading = false;
            state.error = null;
        },
    },
});

export const {
    fetchCapabilitiesStart,
    fetchCapabilitiesSuccess,
    fetchCapabilitiesFailure,
    clearCapabilities,
} = capabilitiesSlice.actions;

export default capabilitiesSlice.reducer;
